import { useContext } from 'react'
import TripContext from 'tripPlanner/contexts/TripContext'

/** Convenience hook, since we often use the trip context just to check if the use has edit permission */
export default function useCanEditTrip() {
  const tripContext = useContext(TripContext)
  return tripContext?.permissions.canEdit ?? false
}
